import React from "react";
import classes from "./MultiLineEllipsis.module.css";
const MultiLineEllipsis = ({
  Tag = "p",
  line = 1,
  children,
  className,
  ...rest
}) => {
  return (
    <Tag
      className={`${classes["multiline-ellipsis"]} ${className}`}
      style={{ WebkitLineClamp: line }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default MultiLineEllipsis;
